<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">优惠券充值</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual">
            <div class="formbody">
                <div class="formtitle">
                    <span>优惠券充值</span>
                </div> 
                <ul class="forminfo">
                    <li>
                        <label>优惠券卡号<b>*</b></label>
                        <div class="vocation">
                            <input type="text" v-model="cardId" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style='margin-left: 20px;'>请输入优惠券卡号</i>
                    </li>
                    <li>
                        <label>密码<b>*</b></label>
                        <div class="vocation">
                            <input type="password" v-model="cardPwd" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style='margin-left: 20px;'>密码长度为6-12</i>
                    </li>
                    <li>
                        <label>&nbsp;</label><input class="sure" type="button" value="确定" @click="uservoucher()">
                        <!-- <label>&nbsp;</label><input class="sure" type="button" value="点击抽奖" @click="choujiang()"> -->
                    </li>
                </ul>
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="@/images/dp.png" alt="提醒" /></span>
                    <b>注意事项</b>
                </div>
                <ul class="infolist">
                    <li><span class="ea2020">支付宝积分－ 话费券 使用规则</span></li> 
                    <li>* 限在指定日期前充值使用</li>
                    <li> * 优惠券卡号只能使用一次，不能兑换现金或兑换使用其他业务 </li> 
                    <li>* 对应每个用户，同一业务限一次优惠，不能重复充值或享受多重优惠</li>
                    <li><span class="ea2020">支付宝积分－400直拨号话费券 使用规则</span></li> 
                    <li>* 不能在线充值，需在客服帮助下按面值选取相应套餐的400直拨电话号码一个，直接抵充话费，在套餐内免费使用</li>
                    <li>* 话费按接听0.3元/分钟计费， 超出赠送部分时，可以选择关闭或续费</li> 
                    <li>* 必须如实填写开通材料，承诺把400号码对外公布在对应的网店、网站或公司宣传材料上试用</li>
                    <li>* 如开通材料虚假或用于非法用途，或不做宣传使用，我们保留随时停止试用的权利</li>
                    <li>
                        <img src="@/images/dp.png" alt="提醒" style="width:25px;height:25px;"/>
                        <!-- <a href="http://www.2office.cn/c4006xuanhao.htm" target="_blank" style="color:#00a4ac;">
                            400在线选号平台：立即选号，马上申请，快速开通 进入...
                        </a> -->
                        <a href="http://4006.2office.cn/lkszjreo/wqi4rpo/ewirwed/qncyrq/oijoijfkiej.aspx" target="_blank" style="color:#00a4ac;">
                            400在线选号平台：立即选号，马上申请，快速开通 进入...
                        </a>
                        &nbsp;&nbsp;&nbsp;挑选你的400号码后，请与我们联系,进行预占，开通材料准备。
                    </li>
                </ul>
            </div> 
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            cardId: '',
            cardPwd: '',
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    methods: {
        uservoucher() {
            if(this.cardId.trim().length < 5)
            {
                this.$alert("请输入优惠券卡号!")
                return false;
            }
            //判断输入的卡号是整数
            var b=/^(\d+)?$/;
            if(!b.exec(this.cardId))
            {
                this.$alert("优惠券卡号为数字")
                return false;
            }
            if(this.cardPwd.trim().length < 6)
            {
                this.$alert("请输入优惠券密码!")
                return false;
            }
            var that = this
            let param = {'cardId': this.cardId, 'cardPwd': this.cardPwd}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/uservoucher.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    //跳转到抽奖页面
                    that.$router.push("choujiang")
                    // that.$router.push({
                    //     path: "/choujiang",
                    //     query: {'cjNum': res.data.cjNum}
                    // })
                }
                else if("0100004" == res.data.code)
                {
                    //优惠券充值成功
                    that.$alert(res.data.msg)
                    that.cardId = ''
                    that.cardPwd = ''
                    that.$router.push("/uservoucher")
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/uservoucher.vue